import { RestSlice } from 'src/redux/rest.slice';
import { Resource, localizationService } from 'src/services';
import { Recipient } from '@rcp/types';

export const recipientSlice = new RestSlice<Recipient>(
	localizationService.getLocalizedString('extractor.cleaningNotice.recipient'),
	Resource.Recipient
);
export const recipientSliceReducer = recipientSlice.rests.reducer;
